import moment from "moment";
import "moment/locale/pt-br";

export const maskCPF = (cpf: string): string | undefined => {
  try {
    cpf = cpf.replace(/\D/g, "");
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    return cpf;
  } catch (error) {
    /* istanbul ignore next */
    console.log(error);
    return;
  }
};

export const maskPix = (pixCode: string): string => {
  try {
    const formater = pixCode.match(/.{1,25}/g);
    return formater?.[0] + "..." || "";
  } catch (error) {
    console.log(error);
    return "";
  }
};

export function maskCPFeCNPJ(document: string): string {
  if (
    !document ||
    document === null ||
    document === undefined ||
    document.includes("null")
  ) {
    return "";
  }

  document = document.replace(/\D/g, "");
  if (document.length > 11) {
    document = document.replace(/^(\d{2})(\d)/, "$1.$2");
    document = document.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    document = document.replace(/\.(\d{3})(\d)/, ".$1/$2");
    document = document.replace(/(\d{4})(\d)/, "$1-$2");
  } else {
    document = document.replace(/\D/g, "");
    document = document.replace(/(\d{3})(\d)/, "$1.$2");
    document = document.replace(/(\d{3})(\d)/, "$1.$2");
    document = document.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  return document;
}

export function maskCNPJ(document: string): string {
  document = document.replace(/\D/g, "");
  document = document.replace(/^(\d{2})(\d)/, "$1.$2");
  document = document.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
  document = document.replace(/\.(\d{3})(\d)/, ".$1/$2");
  document = document.replace(/(\d{4})(\d)/, "$1-$2");

  return document;
}

export function maskDate(date: string): string | void {
  try {
    if (date === null || date === undefined || date.includes("null")) {
      return "";
    }

    date = date.replace(/\D/g, "").slice(0, 10);
    date = date.replace(/(\d{2})(\d)/, "$1/$2");
    date = date.replace(/(\d{2})(\d)/, "$1/$2");

    return date;
  } catch (error) {
    /* istanbul ignore next */
    console.log(error);
  }
}

export function maskDateUTF(
  date: string | Date | moment.Moment,
  format?: string,
  defaultDate?: string
): string {
  try {
    return moment(date, defaultDate ? defaultDate : "").format(
      format ? format : "DD [de] MMMM"
    );
  } catch (error) {
    console.log(error);
    return date.toString();
  }
}

export const maskPhoneNumber = (phone = ""): string | undefined => {
  try {
    if (phone === null || phone === undefined || phone.includes("null")) {
      return "";
    }

    phone = phone.replace(/\D/g, "");

    if (phone.length > 11) {
      return phone.substring(0, 11);
    }

    phone = phone.replace(/\D/g, "");
    phone = phone.replace(/(\d{0})(\d)/, "($1$2");
    phone = phone.replace(/(\d{2})(\d)/, "$1) $2");
    phone = phone.replace(/(\d{5})(\d{1,4})$/, "$1-$2");

    return phone;
  } catch (error) {
    /* istanbul ignore next */
    console.log(error);
    return;
  }
};

export const maskPhoneNumberWithoutAreaCode = (phone = ""): string => {
  try {
    if (phone === null || phone === undefined || phone.includes("null")) {
      return "";
    }

    if (phone.length > 10) {
      return phone.substring(0, 10);
    }

    phone = phone.replace(/\D/g, "");
    phone = phone.replace(/(\d{5})(\d{1,4})$/, "$1-$2");
    return phone;
  } catch (error) {
    /* istanbul ignore next */
    console.log(error);
    return "";
  }
};

export const maskCurrency = (amount: string): string => {
  try {
    if (amount === "") {
      return "";
    }
    if (amount.length === 2) {
      return "";
    }

    amount = amount.replace(/\D/g, "");
    let tmp = amount + "";
    tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
    if (tmp.length > 6) {
      tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
    }
    if (tmp.length < 4) {
      return `R$ 0${tmp}`;
    }
    return `R$${tmp}`;
  } catch (error) {
    console.log(error);
    return "";
  }
};

export const maskDigitableLine = (digitableLine: string): string => {
  try {
    if (
      digitableLine === null ||
      digitableLine === undefined ||
      digitableLine.includes("null")
    ) {
      return "";
    }
    if (digitableLine.length > 55) {
      return digitableLine.substring(0, 54);
    }
    digitableLine = digitableLine.replace(/\D/g, "");

    if (digitableLine.length > 5) {
      digitableLine = digitableLine.replace(/(\d{5})(\d)/, "$1.$2");
      digitableLine = digitableLine.replace(/(\d{5})(\d)/, "$1 $2");
      digitableLine = digitableLine.replace(/(\d{5})(\d)/, "$1.$2");
      digitableLine = digitableLine.replace(/(\d{6})(\d)/, "$1 $2");
      digitableLine = digitableLine.replace(/(.\d{6} \d{5})(\d)/, "$1.$2");
      digitableLine = digitableLine.replace(
        /(\d{5}.\d{5} \d{5}.\d{6} \d{5}.\d{6})(\d)/,
        "$1 $2"
      );
      digitableLine = digitableLine.replace(
        /(\d{5}.\d{5} \d{5}.\d{6} \d{5}.\d{6} \d{1})(\d)/,
        "$1 $2"
      );
    }

    return digitableLine;
  } catch (error) {
    console.log(error);
    return "";
  }
};

export const maskCurrencyReal = (amount: string): string => {
  try {
    if (amount.length === 2) {
      return "";
    }

    if (amount === "0") {
      return "R$ 0,00";
    }

    amount = amount.replace(/\D/g, "");
    let tmp = amount + "";
    if (amount.length === 1) {
      tmp = `,${amount}`;
    }
    console.log(tmp);
    tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
    if (tmp.length > 6) {
      tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
    }
    if (tmp.length > 8) {
      tmp = tmp.replace(/([0-9]{1})([0-9]{3})/g, "$1.$2");
    }
    return `R$ ${tmp}`;
  } catch (error) {
    console.log(error);
    return "";
  }
};

export const maskLocale = (amount?: string | number): string => {
  const maskError = "R$ -";

  if (amount === null || amount === undefined) {
    return maskError;
  }

  try {
    const convertedAmount = Number(amount) / 100;
    const maskAmount = convertedAmount?.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });

    if (maskAmount === "R$ NaN") {
      return maskError;
    }

    return maskAmount;
  } catch (error) {
    return maskError;
  }
};

export const securityCellhone = (cellphone?: string): string => {
  if (cellphone) {
    cellphone = cellphone.replace(/\D/g, "");
    cellphone = cellphone.replace(
      /(\d{1})(\d{1}\d{1}\d{1}\d{1})(\d{1}\d{1}\d{1}\d{1})/,
      "$1 ****-$3"
    );
    console.log(cellphone);
    return cellphone;
  }
  return "";
};

export const maskProviderName = (provider?: string | any): string | any => {
  if (typeof provider !== "string") {
    return provider;
  }

  if (provider === "GOOGLEPLAY VARIAVEL") {
    return "GOOGLE PLAY VARIÁVEL";
  }

  if (provider === "GOOGLEPLAY") {
    return "GOOGLE PLAY";
  }

  return provider;
};
